// GEDEON: Sticky Add to Cart - Mobile
(function () {
  'use strict';

  if (window.matchMedia('(min-width: 750px)').matches) return;

  var UNAVAILABLE_TEXT_PATTERN = /(sold\s*out|unavailable|wyprzedane|niedost[e\u0119]pn|brak\s+w\s+magazynie)/i;
  var sticky = null;
  var stickyBtn = null;
  var stickyTitle = null;
  var stickyPrice = null;
  var observedButton = null;
  var observedProductInfo = null;
  var buttonObserver = null;
  var productInfoObserver = null;
  var visibilityObserver = null;
  var visibilityTarget = null;
  var syncFrame = null;
  var subscriptionsReady = false;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getProductInfo() {
    return document.querySelector('product-info[id^="MainProduct"]')
      || document.querySelector('product-info');
  }

  function getProductScope() {
    return getProductInfo() || document;
  }

  function queryInProductScope(selector) {
    var scope = getProductScope();
    return scope.querySelector(selector) || document.querySelector(selector);
  }

  function getOriginalButton() {
    return queryInProductScope('.product-form__submit')
      || queryInProductScope('button[name="add"]')
      || queryInProductScope('input[name="add"]');
  }

  function getButtonText(button, fallbackText) {
    if (!button) return normalizeText(fallbackText);

    var textElement = button.querySelector('[data-add-to-cart-text]')
      || button.querySelector('span');
    var text = normalizeText(textElement ? textElement.textContent : button.textContent);

    if (!text) text = normalizeText(button.getAttribute('aria-label'));
    if (!text && 'value' in button) text = normalizeText(button.value);

    return text || normalizeText(fallbackText);
  }

  function hasUnavailableText(button) {
    return UNAVAILABLE_TEXT_PATTERN.test(getButtonText(button, ''));
  }

  function isButtonDisabled(button) {
    if (!button) return true;

    return button.disabled
      || button.hasAttribute('disabled')
      || button.getAttribute('aria-disabled') === 'true'
      || button.getAttribute('aria-busy') === 'true'
      || button.classList.contains('loading')
      || button.classList.contains('is-loading')
      || hasUnavailableText(button);
  }

  function isPendingVariantUpdate(button) {
    if (!button) return true;

    return (button.disabled || button.hasAttribute('disabled'))
      && !button.classList.contains('loading')
      && !button.classList.contains('is-loading')
      && !hasUnavailableText(button);
  }

  function getProductTitleText() {
    var title = queryInProductScope('.product__title') || queryInProductScope('h1');
    return title ? normalizeText(title.textContent) : '';
  }

  function getPriceText() {
    var priceWrapper = queryInProductScope('[id^="price-"]');
    if (priceWrapper && priceWrapper.classList.contains('hidden')) return '';

    var priceRoot = priceWrapper && priceWrapper.querySelector('.price')
      ? priceWrapper.querySelector('.price')
      : queryInProductScope('.price');
    if (!priceRoot || priceRoot.classList.contains('hidden')) return '';

    var priceItem = null;
    if (priceRoot.classList.contains('price--on-sale')) {
      priceItem = priceRoot.querySelector('.price__sale .price-item--sale')
        || priceRoot.querySelector('.price__sale .price-item--last');
    }

    if (!priceItem) {
      priceItem = priceRoot.querySelector('.price__regular .price-item--regular')
        || priceRoot.querySelector('.price-item--regular')
        || priceRoot.querySelector('.price-item--last');
    }

    return priceItem ? normalizeText(priceItem.textContent) : '';
  }

  function syncStickyContent() {
    if (!stickyBtn) return;

    var originalBtn = getOriginalButton();
    var buttonText = getButtonText(originalBtn, stickyBtn.textContent);
    var disabled = isButtonDisabled(originalBtn);
    var titleText = getProductTitleText();
    var priceText = isPendingVariantUpdate(originalBtn) ? '' : getPriceText();

    if (buttonText) stickyBtn.textContent = buttonText;
    stickyBtn.disabled = disabled;
    stickyBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');

    if (stickyTitle) stickyTitle.textContent = titleText;
    if (stickyPrice) {
      stickyPrice.textContent = priceText;
      stickyPrice.hidden = !priceText;
    }
  }

  function requestSync() {
    if (syncFrame) window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(function () {
      syncFrame = null;
      refreshBindings();
      syncStickyContent();
    });
  }

  function disconnectButtonObserver() {
    if (buttonObserver) buttonObserver.disconnect();
    buttonObserver = null;
    observedButton = null;
  }

  function observeOriginalButton(originalBtn) {
    if (observedButton === originalBtn && buttonObserver) return;

    disconnectButtonObserver();
    if (!originalBtn) return;

    var observerTarget = originalBtn.closest('product-form')
      || originalBtn.closest('form')
      || originalBtn;

    observedButton = originalBtn;
    buttonObserver = new MutationObserver(requestSync);
    buttonObserver.observe(observerTarget, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function disconnectProductInfoObserver() {
    if (productInfoObserver) productInfoObserver.disconnect();
    productInfoObserver = null;
    observedProductInfo = null;
  }

  function observeProductInfo(productInfo) {
    if (observedProductInfo === productInfo && productInfoObserver) return;

    disconnectProductInfoObserver();
    if (!productInfo) return;

    observedProductInfo = productInfo;
    productInfoObserver = new MutationObserver(requestSync);
    productInfoObserver.observe(productInfo, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy', 'value'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function updateVisibilityObserver(originalBtn) {
    if (visibilityTarget === originalBtn && visibilityObserver) return;

    if (visibilityObserver) visibilityObserver.disconnect();
    visibilityObserver = null;
    visibilityTarget = null;

    if (!originalBtn || !sticky) {
      if (sticky) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    visibilityTarget = originalBtn;
    visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

    visibilityObserver.observe(originalBtn);
  }

  function refreshBindings() {
    var originalBtn = getOriginalButton();

    observeProductInfo(getProductInfo());
    observeOriginalButton(originalBtn);
    updateVisibilityObserver(originalBtn);
  }

  function setupSubscriptions() {
    if (subscriptionsReady) return;
    subscriptionsReady = true;

    document.addEventListener('product-info:loaded', requestSync);

    if (typeof subscribe === 'function'
      && typeof PUB_SUB_EVENTS !== 'undefined'
      && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, requestSync);
    }
  }

  function initStickyATC() {
    var originalBtn = getOriginalButton();

    if (sticky) {
      requestSync();
      return;
    }

    if (!originalBtn || document.querySelector('.sticky-atc')) return;

    sticky = document.createElement('div');
    sticky.className = 'sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');

    var productInfo = document.createElement('div');
    productInfo.className = 'sticky-atc__product-info';

    var productText = document.createElement('div');
    stickyTitle = document.createElement('div');
    stickyTitle.className = 'sticky-atc__title';

    stickyPrice = document.createElement('div');
    stickyPrice.className = 'sticky-atc__price';

    productText.appendChild(stickyTitle);
    productText.appendChild(stickyPrice);
    productInfo.appendChild(productText);

    stickyBtn = document.createElement('button');
    stickyBtn.className = 'sticky-atc__btn button button--primary';
    stickyBtn.type = 'button';
    stickyBtn.id = 'sticky-atc-btn';

    sticky.appendChild(productInfo);
    sticky.appendChild(stickyBtn);
    document.body.appendChild(sticky);

    setupSubscriptions();
    refreshBindings();
    syncStickyContent();

    stickyBtn.addEventListener('click', function (event) {
      var currentOriginalBtn = getOriginalButton();

      syncStickyContent();
      if (isButtonDisabled(stickyBtn) || isButtonDisabled(currentOriginalBtn)) {
        event.preventDefault();
        return;
      }

      currentOriginalBtn.click();
    });
  }

  function scheduleStickyATC() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initStickyATC, { timeout: 1200 });
      return;
    }
    window.setTimeout(initStickyATC, 350);
  }

  document.addEventListener('product-info:loaded', scheduleStickyATC);

  if (document.readyState === 'complete') {
    scheduleStickyATC();
    return;
  }

  window.addEventListener('load', scheduleStickyATC, { once: true });
  if (document.readyState === 'interactive') {
    scheduleStickyATC();
  }
})();
